export const NewAdPageTestIds = {
  categorySelect: {
    box: 'category-select-box',
    drawer: 'category-select-drawer',
    subdrawer: 'category-select-subdrawer',
    categoryItem: 'category-select-category-item',
    subcategoryItem: 'category-select-subcategory-item',
  },
  form: 'new-ad-form',
};
